import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";

//Import Team Box
import TeamBox from "./team-box";

class AboutUs extends Component {
  state = {
    members: [
      {
        id: 1,
        name: "生貝 武俊(Ikegai Taketoshi)",
        image: "assets/images/team/comming.png",
        post: "代表取締役, 開発",
      },
      {
        id: 2,
        name: "非常勤メンバー",
        image: "assets/images/team/comming.png",
        post: "開発, ビジネスコミュニケーション",
      }
    ],
  };
  render() {
    return (
      <React.Fragment>
        <section className="section" id="about">
          <Container>
            <Row>
              <Col lg={{ size: 8, offset: 2 }}>
                <div className="about-title mx-auto text-center">
                  <h2 className="font-weight-light">
                    Transform Navi株式会社{" "}
                  </h2>
                  <p className="text-muted pt-4">
                    Webシステム/スマホアプリを企画・開発・運用までトータルプロデュース<br />
                    小規模から大規模までシステムプロジェクトのマネジメント・システム監査にも対応<br />
                    Javascript/Typescript/React/Next.js/Node.js/API連携/WebRTC通信/顔認証・検出に強み<br />
                    <br />
                    プライバシーに配慮しながら写真の活用が行えるTorune β版をリリース(2025年6月)
                  </p>
                </div>
              </Col>
            </Row>
            <Row className="mt-5 flex justify-center">
              {/* Render Team members */}
              {this.state.members.map((member, key) => (
                <TeamBox
                  key={key}
                  name={member.name}
                  image={member.image}
                  post={member.post}
                />
              ))}
            </Row>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}

export default AboutUs;
